const landingPageClasses = {
  bannerContainer: 'absolute lg:pb-8 lg:mb-16 w-screen z-0',
  banner: 'w-full brightness-50 opacity-8 h-[800px] object-none',
  textContainer:
    'flex flex-col items-center justify-center gap-8 px-auto mx-auto w-screen max-w-screen-lg lg:px-32 md:px-16 my-auto lg:py-8 blur-none h-[800px] bg-black bg-opacity-30',
}

export default landingPageClasses
